<script lang="ts">

    import { VehicleLimitItem } from "../../VehicleLimit/VehicleLimitItem";
    import TemplateIcon from "../../../../shared/Icons/TemplateIcon.svelte";
    import { _ } from "svelte-i18n";

    export let alerts: any;
    export let color: string = VehicleLimitItem._VEHICLE_LIMIT_COLOR_ERROR;
    export let scale: number = 0.5;

    let types = {
        parcels: {src: VehicleLimitItem._ALERT_ICON_PARCELS, title: 'Vehicle_limit_parcel_limit_count'},
        total_weight: {src: VehicleLimitItem._ALERT_ICON_TOTAL_WEIGHT, title: 'Vehicle_limit_weight_limit_count'},
        time_window: {src: VehicleLimitItem._ALERT_ICON_TIME_WINDOW, title: 'Vehicle_limit_time_window_count'},
    };
    for (let t in types) {
        types[t].src = 'data:image/svg+xml;base64,' + btoa(types[t].src.replace(/\{color\}/g, color));
        types[t].title = $_(types[t].title, {values: {count: alerts[t]}});
    };

</script>

<div class="summary-alerts">
    {#each Object.entries(alerts) as [type, count]}
        {#if count > 0}
            <div class="alert">
                <TemplateIcon src={types[type].src} {scale} alt={types[type].title} hover={types[type].title} on:click />
                <span title={types[type].title}>{count}</span>
            </div>
        {/if}
    {/each}
</div>

<style>
    .summary-alerts {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .alert {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 10px;
    }
    .alert span {
        display: inline-block;
        margin-left: 3px;
    }
</style>
